import React from 'react'

const HeadingText = ({heading,text,children,normal}) => {
  if(normal){
    return <div>
      <span className='heading-text'>{heading}</span>&nbsp;&nbsp;{text}
    </div>
  }
  else{
    return (
      <div className="flex-container">
          <div className="left-column heading-text">{heading}</div>
          <div className="right-column" style={{marginTop:!children ? "0px" : "-3px"}}>{text}{children}</div>
      </div>
    )
  }
}

export default HeadingText